import { Bold } from "@faire/web--source/ui/Typography/Span";
import React, { type JSX } from "react";

export const BoldFormatting = (chunk: JSX.Element) => {
  return <Bold>{chunk}</Bold>;
};
